// extracted by mini-css-extract-plugin
export default {"container":"Rewards_container__XUifE","dividerText":"Rewards_dividerText__mhhIm","textWrapper":"Rewards_textWrapper__X63ev"};